<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { CAMPAIGN_STATUS, getCampaignStatusOptions } from "../../../../utils/statusEngine.js";
  import { loadAnakatechClients } from "./utils/anakatechCatalogs.js";
  import Dropdown from "../../../ui/Dropdown.svelte";

  export let filters = {
    client: "",
    clientId: "",
    clientName: "",
    campaignName: "",
    statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
  };
  export let icons = {};

  const dispatch = createEventDispatcher();

  const STATUS_OPTIONS = getCampaignStatusOptions();
  let clients = [];

  async function loadClients() {
    try {
      const catalog = await loadAnakatechClients();
      clients = catalog.clients;
    } catch (err) {
      console.error("Error loading clients:", err);
    }
  }

  function clearFilters() {
    filters = {
      client: "",
      clientId: "",
      clientName: "",
      campaignName: "",
      statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
    };
  }

  function handleClientChange(event) {
    const clientCode = event.detail || "";
    const selected = clients.find(
      (client) => String(client?.code) === String(clientCode),
    );
    filters = {
      ...filters,
      client: clientCode,
      clientId: selected?.id ?? "",
      clientName:
        selected?.namesite ?? selected?.name ?? selected?.clientName ?? "",
    };
  }

  function handleStatusChange(event) {
    filters = {
      ...filters,
      statuses: Array.isArray(event.detail)
        ? event.detail.map(Number).filter(Number.isFinite)
        : [],
    };
  }

  onMount(loadClients);
</script>

<section class="filter-panel" aria-label="Filtros de campañas Anakatech">
  <div class="filter-grid">
    <div class="field">
      <span class="field-label">Cliente</span>
      <Dropdown
        options={clients}
        bind:value={filters.client}
        placeholder="Todos"
        valueKey="code"
        labelKey="namesite"
        isStructuredDescription={true}
        paramStructuredName={["code", "namesite"]}
        on:change={handleClientChange}
      />
    </div>

    <div class="field">
      <label for="anakatech-campaign-filter">Campaña</label>
      <input
        id="anakatech-campaign-filter"
        class="form-control"
        placeholder="Ej. Black Friday"
        bind:value={filters.campaignName}
      />
    </div>

    <div class="field">
      <span class="field-label">Estado</span>
      <Dropdown
        options={STATUS_OPTIONS}
        value={filters.statuses}
        placeholder="Todos"
        valueKey="value"
        labelKey="label"
        multiple={true}
        on:change={handleStatusChange}
      />
    </div>
  </div>

  <div class="toolbar">
    <button
      type="button"
      class="toolbar-button clear-button"
      on:click={clearFilters}
      title="Limpiar filtros"
    >
      Limpiar
    </button>

    <button
      type="button"
      class="toolbar-button create-button"
      on:click={() => dispatch("create")}
    >
      <span class="button-icon" aria-hidden="true">{@html icons.add || "+"}</span>
      Crear Free Spin
    </button>

  </div>
</section>

<style>
  .filter-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem;
    align-items: end;
    margin: 0 10px 0.5rem;
    padding: 0.75rem;
    border: 1px solid var(--bs-border-color, #e5e7eb);
    border-radius: 0.5rem;
    background: #fff;
  }

  .filter-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(140px, 1fr));
    gap: 0.6rem;
    align-items: end;
  }

  .field {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }

  .field label,
  .field-label {
    display: block;
    margin-bottom: 0.3rem;
    color: #666;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .field input {
    min-height: 38px;
    padding: 0.4rem 0.55rem;
    border: 1px solid var(--bs-border-color, #e2e6ea);
    border-radius: 0.4rem;
    background: #fff;
    color: #333;
    font-size: 0.875rem;
  }

  .field input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  }

  .toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .toolbar-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    min-width: max-content;
    padding: 0 1rem;
    border-radius: 0.4rem;
    font-size: 0.85rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
  }

  .create-button {
    gap: 0.4rem;
    border: 1px solid #2a1a28;
    background: #2a1a28;
    color: #fff;
    box-shadow: 0 1px 2px rgba(42, 26, 40, 0.12);
  }

  .create-button:hover {
    border-color: #ff0090;
    background: #ff0090;
  }

  .clear-button {
    border: 1px solid #cfc8cd;
    background: #fff;
    color: #2a1a28;
    box-shadow: 0 1px 2px rgba(42, 26, 40, 0.06);
  }

  .clear-button:hover {
    border-color: #8f818a;
    background: #f7f2f5;
  }

  .toolbar-button:focus-visible {
    border-color: #ff0090;
    outline: 0;
    box-shadow: 0 0 0 3px rgba(255, 0, 144, 0.15);
  }

  .button-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1200px) {
    .filter-panel {
      grid-template-columns: 1fr;
    }

    .filter-grid {
      grid-template-columns: repeat(3, minmax(140px, 1fr));
    }
  }

  @media (max-width: 640px) {
    .filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .toolbar {
      width: 100%;
      flex-wrap: wrap;
    }

    .toolbar-button {
      flex: 1 1 auto;
    }
  }
</style>
